import React  from 'react';
import { Link, NavLink } from 'react-router-dom';
import "./Home.css";
import { FaHome, FaDatabase, FaBriefcase } from "react-icons/fa";
import { Nav, Navbar } from 'react-bootstrap';

const Sidebar = (props) => {
 
  
  return (
  <>

    {/* <div className='sidebar-main '> */}
    {/* {console.log('showtext is ',props.showText)} */}
    <div className={`sidebar-main ${props.disable ? 'disable': '' }`}>
      <div className="d-flex flex-column flex-shrink-0 p-3 w-75 sidebar-inner">
        <a href="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">          
          <b><span className="fs-4 text-dark dash-text">Dashboard</span></b>
        </a>
        <hr/>

        <Navbar bg="light" expand="lg">
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <NavLink to={'/home'} className="icon-text">
            <FaHome />Home
          </NavLink>
          <NavLink to={'/company'} className="icon-text">
            <FaDatabase /> Company data
          </NavLink>
          <NavLink to={'/portfolio'} className="icon-text">
            <FaBriefcase /> Portfolio
          </NavLink>
        </Nav>
      </Navbar.Collapse>
    </Navbar> 
          
      </div>
    </div>
    
  </>
  )
}

export default Sidebar;